import { render, staticRenderFns } from "./safetyGearRequestAppr.vue?vue&type=template&id=21c74f40"
import script from "./safetyGearRequestAppr.vue?vue&type=script&lang=js"
export * from "./safetyGearRequestAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21c74f40')) {
      api.createRecord('21c74f40', component.options)
    } else {
      api.reload('21c74f40', component.options)
    }
    module.hot.accept("./safetyGearRequestAppr.vue?vue&type=template&id=21c74f40", function () {
      api.rerender('21c74f40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/sop/sas/safetyGearRequestAppr.vue"
export default component.exports